import Axios from "axios";
import CryptoJS from "crypto-js";
import { BaseUrl } from "./Environment";
import store from "../src/components/GlobalState/store";
import { getAllBankAccountsDataAPI, addBankAccountAPI } from "./service/service";

const SECRET_KEY = store.getState().globalState?.secretKey;

// Encrypt and store in localStorage
export const setSecureItem = (key, value) => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    localStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error("Error encrypting data:", error);
  }
};

// Retrieve and decrypt from localStorage
export const getSecureItem = (key) => {
  try {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

// Remove item from localStorage
export const removeSecureItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing data:", error);
  }
};

const loggedinUser = getSecureItem("loggedinUser");

const currencyArray = [
  { code: "AUD", symbol: "$" },
  { code: "BHD", symbol: ".د.ب‎" },
  { code: "BDT", symbol: "৳" },
  { code: "BWP", symbol: "P" },
  { code: "BRL", symbol: "R$" },
  { code: "KHR", symbol: "៛" },
  { code: "COP", symbol: "$" },
  { code: "EGP", symbol: "£" },
  { code: "GHS", symbol: "¢" },
  { code: "HKD", symbol: "$" },
  { code: "INR", symbol: "₹" },
  { code: "IDR", symbol: "Rp" },
  { code: "JMD", symbol: "J$" },
  { code: "KES", symbol: "KSh" },
  { code: "KWD", symbol: "د.ك " },
  { code: "MYR", symbol: "RM" },
  { code: "MUR", symbol: "₨" },
  { code: "MXN", symbol: "$" },
  { code: "NAD", symbol: "$" },
  { code: "NZD", symbol: "$" },
  { code: "NGN", symbol: "₦" },
  { code: "OMR", symbol: "﷼" },
  { code: "PKR", symbol: "₨" },
  { code: "PHP", symbol: "₱" },
  { code: "QAR", symbol: "﷼" },
  { code: "RWF", symbol: "R₣" },
  { code: "SAR", symbol: "﷼" },
  { code: "SGD", symbol: "$" },
  { code: "ZAR", symbol: "R" },
  { code: "LKR", symbol: "₨" },
  { code: "TZS", symbol: "TSh" },
  { code: "THB", symbol: "฿" },
  { code: "AED", symbol: " د.إ" },
  { code: "VND", symbol: "₫" },
];

export const UgandaDistricts = [
  { value: "Abim", label: "Abim" },
  { value: "Adjumani", label: "Adjumani" },
  { value: "Agago", label: "Agago" },
  { value: "Alebtong", label: "Alebtong" },
  { value: "Amolatar", label: "Amolatar" },
  { value: "Amudat", label: "Amudat" },
  { value: "Amuria", label: "Amuria" },
  { value: "Amuru", label: "Amuru" },
  { value: "Apac", label: "Apac" },
  { value: "Arua", label: "Arua" },
  { value: "Arua City", label: "Arua City" },
  { value: "Budaka", label: "Budaka" },
  { value: "Bududa", label: "Bududa" },
  { value: "Bugiri", label: "Bugiri" },
  { value: "Bugweri", label: "Bugweri" },
  { value: "Buhweju", label: "Buhweju" },
  { value: "Buikwe", label: "Buikwe" },
  { value: "Bukedea", label: "Bukedea" },
  { value: "Bukomansimbi", label: "Bukomansimbi" },
  { value: "Bukwo", label: "Bukwo" },
  { value: "Bulambuli", label: "Bulambuli" },
  { value: "Buliisa", label: "Buliisa" },
  { value: "Bundibugyo", label: "Bundibugyo" },
  { value: "Bunyangabu", label: "Bunyangabu" },
  { value: "Bushenyi", label: "Bushenyi" },
  { value: "Busia", label: "Busia" },
  { value: "Butaleja", label: "Butaleja" },
  { value: "Butambala", label: "Butambala" },
  { value: "Butebo", label: "Butebo" },
  { value: "Buvuma", label: "Buvuma" },
  { value: "Buyende", label: "Buyende" },
  { value: "Dokolo", label: "Dokolo" },
  { value: "Fort Portal City", label: "Fort Portal City" },
  { value: "Gomba", label: "Gomba" },
  { value: "Gulu", label: "Gulu" },
  { value: "Gulu City", label: "Gulu City" },
  { value: "Hoima", label: "Hoima" },
  { value: "Hoima City", label: "Hoima City" },
  { value: "Ibanda", label: "Ibanda" },
  { value: "Iganga", label: "Iganga" },
  { value: "Isingiro", label: "Isingiro" },
  { value: "Jinja", label: "Jinja" },
  { value: "Jinja City", label: "Jinja City" },
  { value: "Kaabong", label: "Kaabong" },
  { value: "Kabale", label: "Kabale" },
  { value: "Kabarole", label: "Kabarole" },
  { value: "Kaberamaido", label: "Kaberamaido" },
  { value: "Kagadi", label: "Kagadi" },
  { value: "Kakumiro", label: "Kakumiro" },
  { value: "Kalaki", label: "Kalaki" },
  { value: "Kalangala", label: "Kalangala" },
  { value: "Kaliro", label: "Kaliro" },
  { value: "Kalungu", label: "Kalungu" },
  { value: "Kampala", label: "Kampala" },
  { value: "Kamuli", label: "Kamuli" },
  { value: "Kamwenge", label: "Kamwenge" },
  { value: "Kanungu", label: "Kanungu" },
  { value: "Kapchorwa", label: "Kapchorwa" },
  { value: "Kapelebyong", label: "Kapelebyong" },
  { value: "Karenga", label: "Karenga" },
  { value: "Kasese", label: "Kasese" },
  { value: "Kassanda", label: "Kassanda" },
  { value: "Katakwi", label: "Katakwi" },
  { value: "Kayunga", label: "Kayunga" },
  { value: "Kazo", label: "Kazo" },
  { value: "Kibaale", label: "Kibaale" },
  { value: "Kiboga", label: "Kiboga" },
  { value: "Kibuku", label: "Kibuku" },
  { value: "Kikuube", label: "Kikuube" },
  { value: "Kiruhura", label: "Kiruhura" },
  { value: "Kiryandongo", label: "Kiryandongo" },
  { value: "Kisoro", label: "Kisoro" },
  { value: "Kitagwenda", label: "Kitagwenda" },
  { value: "Kitgum", label: "Kitgum" },
  { value: "Koboko", label: "Koboko" },
  { value: "Kole", label: "Kole" },
  { value: "Kotido", label: "Kotido" },
  { value: "Kumi", label: "Kumi" },
  { value: "Kwania", label: "Kwania" },
  { value: "Kween", label: "Kween" },
  { value: "Kyankwanzi", label: "Kyankwanzi" },
  { value: "Kyegegwa", label: "Kyegegwa" },
  { value: "Kyenjojo", label: "Kyenjojo" },
  { value: "Kyotera", label: "Kyotera" },
  { value: "Lamwo", label: "Lamwo" },
  { value: "Lira", label: "Lira" },
  { value: "Lira City", label: "Lira City" },
  { value: "Luuka", label: "Luuka" },
  { value: "Luweero", label: "Luweero" },
  { value: "Lwengo", label: "Lwengo" },
  { value: "Lyantonde", label: "Lyantonde" },
  { value: "Madi-okollo", label: "Madi-okollo" },
  { value: "Manafwa", label: "Manafwa" },
  { value: "Maracha", label: "Maracha" },
  { value: "Masaka", label: "Masaka" },
  { value: "Masaka City", label: "Masaka City" },
  { value: "Masindi", label: "Masindi" },
  { value: "Mayuge", label: "Mayuge" },
  { value: "Mbale", label: "Mbale" },
  { value: "Mbale City", label: "Mbale City" },
  { value: "Mbarara", label: "Mbarara" },
  { value: "Mbarara City", label: "Mbarara City" },
  { value: "Mitooma", label: "Mitooma" },
  { value: "Mityana", label: "Mityana" },
  { value: "Moroto", label: "Moroto" },
  { value: "Moyo", label: "Moyo" },
  { value: "Mpigi", label: "Mpigi" },
  { value: "Mubende", label: "Mubende" },
  { value: "Mukono", label: "Mukono" },
  { value: "Nabilatuk", label: "Nabilatuk" },
  { value: "Nakapiripirit", label: "Nakapiripirit" },
  { value: "Nakaseke", label: "Nakaseke" },
  { value: "Nakasongola", label: "Nakasongola" },
  { value: "Namayingo", label: "Namayingo" },
  { value: "Namisindwa", label: "Namisindwa" },
  { value: "Namutumba", label: "Namutumba" },
  { value: "Napak", label: "Napak" },
  { value: "Nebbi", label: "Nebbi" },
  { value: "Ngora", label: "Ngora" },
  { value: "Ntoroko", label: "Ntoroko" },
  { value: "Ntungamo", label: "Ntungamo" },
  { value: "Nwoya", label: "Nwoya" },
  { value: "Obongi", label: "Obongi" },
  { value: "Omoro", label: "Omoro" },
  { value: "Otuke", label: "Otuke" },
  { value: "Oyam", label: "Oyam" },
  { value: "Pader", label: "Pader" },
  { value: "Pakwach", label: "Pakwach" },
  { value: "Pallisa", label: "Pallisa" },
  { value: "Rakai", label: "Rakai" },
  { value: "Rubanda", label: "Rubanda" },
  { value: "Rubirizi", label: "Rubirizi" },
  { value: "Rukiga", label: "Rukiga" },
  { value: "Rukungiri", label: "Rukungiri" },
  { value: "Rwampara", label: "Rwampara" },
  { value: "Serere", label: "Serere" },
  { value: "Sheema", label: "Sheema" },
  { value: "Sironko", label: "Sironko" },
  { value: "Soroti", label: "Soroti" },
  { value: "Soroti City", label: "Soroti City" },
  { value: "Ssembabule", label: "Ssembabule" },
  { value: "Terego", label: "Terego" },
  { value: "Tororo", label: "Tororo" },
  { value: "Wakiso", label: "Wakiso" },
  { value: "Yumbe", label: "Yumbe" },
  { value: "Zombo", label: "Zombo" }
];

export const UgandaDocumentTypes = [
  { value: "National ID", label: "National ID" },
  { value: "Passport", label: "Passport" },
  { value: "Driver's License", label: "Driver's License" },
  { value: "Voter's Card", label: "Voter's Card" },
  { value: "Employment ID or Letter of Employment", label: "Employment ID or Letter of Employment" },
  { value: "Bank Statement (3-6 months)", label: "Bank Statement (3-6 months)" },
  { value: "Mobile Money Statement", label: "Mobile Money Statement" },
  { value: "Credit Reference Bureau Report", label: "Credit Reference Bureau Report" },
  { value: "Utility Bill or Tenancy Agreement", label: "Utility Bill or Tenancy Agreement" },
  { value: "Land titles (freehold, leasehold, mailo)", label: "Land titles (freehold, leasehold, mailo)" },
  { value: "Motor vehicle logbooks", label: "Motor vehicle logbooks" },
  { value: "Fixed assets like machinery or equipment", label: "Fixed assets like machinery or equipment" },
  { value: "Guarantor agreements", label: "Guarantor agreements" }
];


export function getCurrencySymbol(code) {
  for (let i = 0; i < currencyArray.length; i++) {
    if (currencyArray[i].code == code) {
      return currencyArray[i].symbol;
    }
  }
  return "Code not found";
}

export function trialDaysRemaining(startDateStr) {
  const trialPeriodDays = 14;
  // Convert the start date string to a Date object
  const startDate = new Date(startDateStr);
  
  // Get the current date
  const currentDate = new Date();
  
  // Calculate the end date of the trial period
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + trialPeriodDays);
  
  // Calculate the remaining days
  const remainingTime = +endDate - +currentDate;
  const remainingDays = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
  
  // Ensure the remaining days are not negative
  return Math.max(remainingDays, 0);
}

export const getUserTypeDetails = async (userType, companyId,userId) => {
  try {
    const token = getSecureItem("token");
    const headers = {
      Authorization: "Bearer " + token,
    };

    const result = await Axios.get(
      `${BaseUrl}/userType/getUserTypeDetails?userType=${userType}&companyId=${companyId}&userId=${userId}`,
      {
        headers,
      }
    );

    setSecureItem("UsersAccess",
      Object.fromEntries(
        Object.entries(result.data).filter(
          ([key, value]) => typeof value === "boolean"
        )
      )
    );
  } catch (error) {
    console.log("error: " + JSON.stringify(error));
  }
};

export const getAllSettings = async () => {
  try {
    const token = getSecureItem("token");
    const headers = {
      Authorization: "Bearer " + token,
    };

    const result = await Axios.get(
      `${BaseUrl}/settings/getAllSettings?companyId=${loggedinUser?.companyId}&userId=${loggedinUser?.userId}`,
      {
        headers,
      }
    );

    if (result.data) {
      const loanSettings = result.data?.map((val) => ({
        autoUpdate: val?.autoUpdate,
        autoPenalty: val?.autoPenalty,
        autoPenaltyType: val?.autoPenaltyType,
        autoPenaltyFrequency: val?.autoPenaltyFrequency,
        autoPenaltyFrequencyType: val?.autoPenaltyFrequencyType,
        autoPenaltyValue: val?.autoPenaltyValue,
        calculationFrequency: val?.calculationFrequency,
        autoApprove: val?.autoApprove,
        autoSms: val?.autoSms,
        advanceEMI: val?.advanceEMI,
        accumulateNP: val?.accumulateNP,
        settingsId: val?.settingsId
      }))[0];
      
      setSecureItem('LoanSettings', loanSettings);      
    }
  } catch (error) {
    console.log("error: " + JSON.stringify(error));
  }
};

// Function to compress image
// export const compressImage = (file) => {
  
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
    
//     // Read the image as a data URL
//     reader.readAsDataURL(file);

//     reader.onload = (event) => {
//       const img = new Image();
//       img.src = event.target.result;

//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");

//         // Set canvas dimensions to match the original image
//         canvas.width = img.width;
//         canvas.height = img.height;

//         // Draw the image on the canvas
//         ctx.drawImage(img, 0, 0);

//         // Compress image by exporting it to a Blob
//         canvas.toBlob(
//           (blob) => {
//             if (blob.size > 100 * 1024) {
//               resolve(compressImage(file, 0.7 - 0.1)); // Recompress if size is > 100KB
//             } else {
//               resolve(blob); // Return compressed image as Blob
//             }
//           },
//           "image/jpeg",
//           0.7 // Image quality (0.0 - 1.0)
//         );
//       };

//       img.onerror = (err) => {
//         reject(err);
//       };
//     };

//     reader.onerror = (err) => {
//       reject(err);
//     };
//   });
// };
export const compressImage = (file, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        canvas.toBlob(
          async (blob) => {
            if (blob.size > 100 * 1024 && quality > 0.1) {
              // Recursively compress with lower quality
              const lowerQuality = parseFloat((quality - 0.1).toFixed(2));
              const compressedBlob = await compressImage(file, lowerQuality);
              resolve(compressedBlob);
            } else {
              resolve(blob);
            }
          },
          "image/jpeg",
          quality
        );
      };

      img.onerror = reject;
    };

    reader.onerror = reject;
  });
};

export function generateRandomString(length = 10) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export function canAddLoans(planId, planEndDate, maxLoansCanBeAdded, currentlyActiveLoans) {
  // console.log({planId, planEndDate, maxLoansCanBeAdded, currentlyActiveLoans});
  if (planId != 0 && (!planEndDate || new Date(planEndDate) <= new Date())) {
    return false;
  }

  if (currentlyActiveLoans >= maxLoansCanBeAdded) {
    return false;
  }

  // Special case for planId 3: Unlimited loans
  if (planId == 3) {
    return true;
  }

  return true; // All conditions satisfied
}

export function canAddBorrowers(planId, planEndDate, maxBorrowersCanBeAdded, currentlyActiveBorrowers) {
  // console.log({planId, planEndDate, maxLoansCanBeAdded, currentlyActiveLoans});
    
  if (planId != 0 && (!planEndDate || new Date(planEndDate) <= new Date())) {
    return false;
  }

  if (currentlyActiveBorrowers >= maxBorrowersCanBeAdded) {
    return false;
  }

  // Special case for planId 3: Unlimited borrowers
  if (planId == 3) {
    return true;
  }

  return true; // All conditions satisfied
}

export function trialEndDateCalc(startDateStr) {
  const trialPeriodDays = 14;
  // Convert the start date string to a Date object
  const startDate = new Date(startDateStr);


  // Calculate the end date of the trial period
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + trialPeriodDays);
  
  
  // End date
  return endDate;
}

// --------- Bank account checking function ---------

const DEFAULT_ACCOUNT = { code: "0000", bankName: "Cash" };

// Companies we've already verified this session (skip repeat API calls)
const verifiedCompanies = new Set();
// In-flight checks, so simultaneous callers share one request
// (prevents two components from both creating "Cash")
const inFlight = new Map();

// Accepts:
//  - resp.data = [...]                         (accounts exist)
//  - resp.data = { data: [...] }                (accounts exist, wrapped)
//  - resp.data = { status: false, msg: "..." }  (no accounts for this company)
const extractList = (resp) => {
  if (Array.isArray(resp?.data)) return resp.data;
  if (Array.isArray(resp?.data?.data)) return resp.data.data;
  return [];
};

const run = async (companyId, userId) => {
  const listResp = await getAllBankAccountsDataAPI({
    companyId,
    searchQuery: "",
  });

  // An HTTP 200 IS a successful lookup, even when the body's own `status`
  // flag is false (that just means "no accounts for this company yet" -
  // it is not a request failure, so it must NOT stop us from creating Cash).
  const lookupOk = listResp?.status === 200;
  if (!lookupOk) return { created: false, accountId: null, error: true };

  // Any bank account at all -> just use what exists, do nothing
  if (extractList(listResp).length > 0) {
    verifiedCompanies.add(companyId);
    return { created: false, accountId: null };
  }

  // No accounts -> add the default Cash account
  const addResp = await addBankAccountAPI({
    ...DEFAULT_ACCOUNT,
    companyId,
    createdByUserId: userId,
    updatedByUserId: userId,
  });

  if (addResp?.status === 200) {
    verifiedCompanies.add(companyId);
    return {
      created: true,
      accountId: addResp.data?.result?.accountId ?? null,
    };
  }

  return { created: false, accountId: null, error: true };
};

/**
 * Makes sure the company has at least one bank account.
 *  - accounts exist          -> does nothing, existing data is used as is
 *  - accounts list is empty  -> creates { code: "0000", bankName: "Cash" }
 *
 * Safe to call from anywhere, any number of times.
 * Resolves to { created, accountId?, error? } and never throws.
 */
export const ensureDefaultBankAccount = async ({ companyId, userId } = {}) => {
  try {
    const loggedinUser = getSecureItem("loggedinUser");
    const cId = companyId ?? loggedinUser?.companyId;
    const uId = userId ?? loggedinUser?.userId;

    if (!cId) return { created: false, accountId: null, skipped: true };
    if (verifiedCompanies.has(cId)) return { created: false, accountId: null };

    if (!inFlight.has(cId)) {
      inFlight.set(
        cId,
        run(cId, uId).finally(() => inFlight.delete(cId)),
      );
    }
    return await inFlight.get(cId);
  } catch (error) {
    console.error("ensureDefaultBankAccount error:", error);
    return { created: false, accountId: null, error: true };
  }
};

export default ensureDefaultBankAccount;